/* The Diorama — Infinite scroll for collection pages
   Replaces page-based pagination with automatic loading on scroll.
   Works with Dawn's ProductGridContainer + facets filtering. */
(function () {
  'use strict';

  var fetching = false;

  function container() {
    return document.getElementById('ProductGridContainer');
  }

  function getNextLink() {
    var c = container();
    if (!c) return null;
    var wrap = c.querySelector('.pagination-wrapper');
    if (!wrap) return null;

    /* Current page: data-page attribute, or the highlighted item */
    var current = parseInt(wrap.getAttribute('data-page'), 10);
    if (!current || isNaN(current)) {
      var cur = wrap.querySelector('.pagination__item--current');
      current = cur ? parseInt(cur.textContent, 10) : 1;
    }
    if (!current || isNaN(current)) current = 1;

    /* Next link = the anchor whose ?page= equals current + 1
       (class names are unreliable: Dawn swaps --prev/--next on arrows) */
    var links = wrap.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      var url;
      try { url = new URL(links[i].getAttribute('href'), window.location.href); } catch (e) { continue; }
      var p = parseInt(url.searchParams.get('page') || '1', 10);
      if (p === current + 1) return links[i];
    }
    return null;
  }

  function hidePagination() {
    var c = container();
    if (!c) return;
    var wrap = c.querySelector('.pagination-wrapper');
    if (wrap) wrap.style.display = 'none';
  }

  function cleanItem(li) {
    li.classList.remove('scroll-trigger', 'animate--slide-in');
    li.removeAttribute('data-cascade');
    li.style.removeProperty('--animation-order');
  }

  function appendProducts(doc) {
    var newGrid = doc.getElementById('product-grid');
    var grid = document.getElementById('product-grid');
    if (!newGrid || !grid) return;

    Array.prototype.slice.call(newGrid.children).forEach(function (li) {
      cleanItem(li);
      grid.appendChild(li);
    });

    /* Swap in the fetched pagination so the "next" link stays current */
    var oldWrap = container().querySelector('.pagination-wrapper');
    var newWrap = doc.querySelector('#ProductGridContainer .pagination-wrapper');
    if (oldWrap && newWrap) {
      oldWrap.replaceWith(newWrap);
      newWrap.style.display = 'none';
    } else if (oldWrap) {
      oldWrap.remove();
    }
  }

  function setLoading(sentinel, on) {
    sentinel.classList.toggle('is-loading', on);
  }

  function loadMore(sentinel) {
    if (fetching) return;
    var link = getNextLink();
    if (!link) return;

    fetching = true;
    setLoading(sentinel, true);

    fetch(link.href)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        appendProducts(doc);
      })
      .catch(function () { /* network hiccup — user can keep scrolling to retry */ })
      .finally(function () {
        fetching = false;
        setLoading(sentinel, false);
      });
  }

  function init() {
    var c = container();
    if (!c) return;

    hidePagination();

    /* Sentinel lives OUTSIDE the container so facet re-renders don't remove it */
    var sentinel = document.createElement('div');
    sentinel.className = 'infinite-scroll-sentinel';
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.innerHTML = '<span class="infinite-scroll-spinner"></span>';
    c.after(sentinel);

    var style = document.createElement('style');
    style.textContent =
      '.infinite-scroll-sentinel{min-height:1px;display:flex;justify-content:center;padding:1rem 0;}' +
      '.infinite-scroll-spinner{display:none;width:2.4rem;height:2.4rem;border:3px solid rgba(0,0,0,.15);border-top-color:rgba(0,0,0,.6);border-radius:50%;animation:infscroll-spin .8s linear infinite;}' +
      '.infinite-scroll-sentinel.is-loading .infinite-scroll-spinner{display:block;}' +
      '@keyframes infscroll-spin{to{transform:rotate(360deg)}}';
    document.head.appendChild(style);

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) loadMore(sentinel);
          });
        },
        { rootMargin: '900px 0px' }
      );
      io.observe(sentinel);
    } else {
      /* Fallback for very old browsers */
      window.addEventListener('scroll', function () {
        var rect = sentinel.getBoundingClientRect();
        if (rect.top < window.innerHeight + 900) loadMore(sentinel);
      });
    }

    /* Facet filtering / sorting re-renders the grid with fresh pagination — hide it again */
    var mo = new MutationObserver(function () {
      hidePagination();
    });
    mo.observe(c, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
